import { EmblaCarouselType } from 'embla-carousel';

export const addDotBtnsAndClickHandlers = (emblaApi: EmblaCarouselType, dotsNode: HTMLElement): (() => void) => {
  let dotNodes: HTMLElement[] = [];

  const addDotBtnsWithClickHandlers = (): void => {
    dotsNode.innerHTML = emblaApi
      .scrollSnapList()
      .map(
        (_, index) =>
          `<button
              class="embla__dot"
              type="button"
              aria-label="Go to view ${index + 1}"
              aria-pressed="false"
            ></button>`
      )
      .join('');

    const scrollTo = (index: number): void => {
      emblaApi.scrollTo(index);
    };

    dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'));
    dotNodes.forEach((dotNode, index) => {
      dotNode.addEventListener('click', () => scrollTo(index), false);
    });
  };

  const toggleDotBtnsActive = (): void => {
    const previous = emblaApi.previousScrollSnap();
    const selected = emblaApi.selectedScrollSnap();

    if (dotNodes[previous]) {
      dotNodes[previous].classList.remove('embla__dot--selected');
      dotNodes[previous].setAttribute('aria-pressed', 'false');
    }

    if (dotNodes[selected]) {
      dotNodes[selected].classList.add('embla__dot--selected');
      dotNodes[selected].setAttribute('aria-pressed', 'true');
    }
  };

  emblaApi
    .on('init', addDotBtnsWithClickHandlers)
    .on('reInit', addDotBtnsWithClickHandlers)
    .on('init', toggleDotBtnsActive)
    .on('reInit', toggleDotBtnsActive)
    .on('select', toggleDotBtnsActive);

  return (): void => {
    dotsNode.innerHTML = '';
  };
};
